import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AppMenu } from '../../models/app/appMenu.model';
import { Globals } from '../../globals/globals';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { AppLanguage } from '../../models/app/appLanguage.model';
//import cfgApiUrl from '../../../../assets/cfg/cfg.json';
import { TeiasoftToasterService } from '../teiasoft-bucket/teiasoft-toaster.service';
import { RoundDigit } from '../../models/data/roundDigit.model';
import { GroupAuthorization } from '../../models/data/groups.model';
import { DatePipe } from '@angular/common';
import { UserConfiguration } from '../../models/data/userConfiguration.model';
import { GridColumn, GridConfiguration } from '../../teiasoft-bucket/teiasoft-grid-odata/teiasoft-grid-odata.component';
import { withAssetVersion } from '../../utils/asset-version';
//import * as fs from 'fs';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  myVar: any;

  constructor(private httpClient: HttpClient, private globals: Globals, private translate: TranslateService, private teiasoftToaster: TeiasoftToasterService, private datePipe: DatePipe) { }

  /***
   * APP MENU 
   */
  getAppMenu(): Observable<AppMenu[]> {
    return this.httpClient.get<AppMenu[]>(withAssetVersion('assets/mock/menu.json'));
  }

  setGlobalVar(value: any) {
    this.myVar = value;
  }

  getGlobalVar(): any {
    return this.myVar;
  }

  setLanguageTranslateAndDateFormat(): Observable<any> {
    /* this.globals.userLogged!.language! =localStorage.getItem("language")!;//==undefined?"en":localStorage.getItem("language"); */
    let _lang: string = 'en'; //navigator.language.slice(0, 2) == 'it' ? 'it' : 'en';
    if (this.globals.userLogged! && this.globals.userLogged!.language!) _lang = this.globals.userLogged!.language!;

    this.globals.dateFormat = this.globals.userLogged?.dateFormat || 'dd/MM/yyyy';
    this.globals.dateTimeFormat = this.globals.dateFormat + ' HH:mm';
    this.translate.addLangs(['en', 'it', 'de']);
    this.translate.setDefaultLang('en');
    return this.translate.use(_lang);
  }

  getLanguages(): Observable<AppLanguage[]> {
    return this.httpClient.get<AppLanguage[]>(withAssetVersion('assets/mock/languages.json'));
  }

  getApiUrl(): Promise<void> {
    const cfgUrl = withAssetVersion('assets/cfg/cfg.json');

    return fetch(cfgUrl).then(res => res.json())
      .then(json => {
        // Check property
        this.globals.apiUrl = json['apiUrl'];
        if (this.globals.apiUrl == undefined || this.globals.apiUrl == '') {
          let err: any = {
            "error": "Missing apiUrl key in JSON file"
          };
          this.errorReadingCFG(err);
        } else {
          localStorage.setItem('apiUrl', this.globals.apiUrl!);
          //console.log("[QuoteTool] API oData Url:" + this.globals.apiUrl);
        }
      }).catch((err) => {
        this.errorReadingCFG(err);
        throw err; // Re-throw error for the caller to handle if needed
      });
  }

  errorReadingCFG(err: any) {
    this.teiasoftToaster.show("error", "cfg.json file missing or malformed. Please, check console log");
    //console.log("[QuoteTool] Error reading Cfg.json file :", err);
  }

  clearStorage() {
    localStorage.removeItem("token");
    localStorage.clear();
    sessionStorage.removeItem("TS-SELECT-LIST"); // Select
    sessionStorage.removeItem("TS-OPTION-LIST"); // Select Options
    sessionStorage.removeItem("TI-INPUT-LIST"); // Input 
    sessionStorage.removeItem("TL-INPUT-LIST"); // List
    sessionStorage.removeItem("TL-INPUT-OPTION-LIST"); // List Options
    sessionStorage.removeItem("TD-DATETIME-LIST"); // DateTime
    sessionStorage.removeItem("TI-AUTOCOMPLETE-LIST"); // INPUT AUTOCOMPLETE
    sessionStorage.clear();
  }


  // GBR MQBF- 21
  checkDecimal(val: any): any {
    if (val == null || val == undefined || Number.isNaN(val) || val.toString() == 'NaN') return null; //val;
    // Check se è un number valido
    if (val.toString().split(",").length > 2) return 'error';
    if (val.toString().split(".").length > 2) return 'error';
    val = val.toString().replace(',', '.');
    if (isNaN(val)) return 'error';
    val = val.replace(',', '.');
    return parseFloat(val);
  }

  isDecimal(n: number) {
    return (n - Math.floor(n)) !== 0;
  }

  normalizeCustomerItemNo(value: any): string {
    if (value === null || value === undefined) {
      return '';
    }
    return value.toString().trim();
  }

  isCustomerItemNoNumeric(value: any): boolean {
    const normalized = this.normalizeCustomerItemNo(value);
    return /^\d+$/.test(normalized);
  }

  toCustomerItemNoNumber(value: any): number | null {
    if (!this.isCustomerItemNoNumeric(value)) {
      return null;
    }

    const numericValue = Number(this.normalizeCustomerItemNo(value));
    return Number.isNaN(numericValue) ? null : numericValue;
  }

  findDuplicateCustomerItemNoNumbers(values: any[]): number[] {
    const occurrences = new Map<number, number>();

    values.forEach(value => {
      const numericValue = this.toCustomerItemNoNumber(value);
      if (numericValue === null) {
        return;
      }

      occurrences.set(numericValue, (occurrences.get(numericValue) || 0) + 1);
    });

    return Array.from(occurrences.entries())
      .filter(([, count]) => count > 1)
      .map(([value]) => value);
  }

  // SORT NPS AND SCHEDULE
  sortNpSAndSchedule(data: any[]) {
    return data.sort((a, b) => {
      if (a["odMetric"] !== b["odMetric"]) {
        return a["odMetric"] - b["odMetric"];
      }
      if (a["odMetric"] !== b["wtMetric"]) {
        return a["wtMetric"] - b["wtMetric"];
      }
      return a["npsDescription"].localeCompare(b["npsDescription"]);
    });
  }

  // Sort any array of objects by multiple properties
  /*  sortMultiFields(prop: string[]){
     return (a:any,b:any) => {
         for (var i=0; i < prop.length;i++)
         {
             var reg = /^\d+$/;
             var x=1;
             var field1=prop[i];
             if(prop[i].indexOf("-")==0)
             {
                 field1=prop[i].substr(1,prop[i].length);
                 x=-x;
             }
 
             if(reg.test(a[field1]))
             {
                 a[field1]=parseFloat(a[field1]);
                 b[field1]=parseFloat(b[field1]);
             }
             if( a[field1] > b[field1])
                 return x;
             else if(a[field1] < b[field1])
                 return -x;
         }
     }
   } */


  /********************** GET ROUND DIGITS  *************************/
  getRoundDigits(): Observable<RoundDigit[]> {
    return this.httpClient.get<RoundDigit[]>(withAssetVersion('assets/mock/roundDigits.json'));
  }

  /**
   * CHECK IF AUTHORIZED
   * @param unitType 
   * @param section 
   * @returns 
   */
  isAuthorized(unitType: string, func: string, officeId: number | null): boolean {
    let _temp: GroupAuthorization[] | undefined = new Array();

    if(!this.globals.userLogged )
      return false;

    if (officeId == null)
      _temp = this.globals.userLogged?.userAuthorizations?.filter(x => x.unitType == unitType);
    else
      _temp = this.globals.userLogged?.userAuthorizations?.filter(x => x.unitType == unitType && x.unitId == officeId!);

    if (_temp == undefined) return true;
    for (var x = 0; x < _temp.length; x++) {
      if (_temp[x].authorizations!.findIndex(x => x == func) != -1) return true;
    }

    return false;
  }


  /**
   * 
   * @param date 
   * @returns 
   */
  formatDate(date: number): string {
    const dateFormat = this.globals.userLogged!.dateFormat!;
    const formattedDate = this.datePipe.transform(date, dateFormat);
    return formattedDate || '';
  }

  /**
   * Safely returns the current user configuration, ensuring required collections exist.
   */
  getUserConfiguration(): UserConfiguration {
    let userConfiguration: UserConfiguration = new UserConfiguration();
    const storedConfiguration = this.globals.userLogged?.configuration;

    if (storedConfiguration) {
      try {
        userConfiguration = JSON.parse(storedConfiguration);
      } catch {
        userConfiguration = new UserConfiguration();
      }
    }

    if (!userConfiguration.gridsConfigurations) {
      userConfiguration.gridsConfigurations = [];
    }

    return userConfiguration;
  }

  /**
   * Insert or update a grid configuration in the user configuration, avoiding duplicate names.
   */
  upsertGridConfiguration(gridConfiguration: GridConfiguration): UserConfiguration {
    if (!gridConfiguration?.name) {
      return this.getUserConfiguration();
    }

    this.sanitizeGridConfiguration(gridConfiguration);

    const userConfiguration = this.getUserConfiguration();
    const gridsConfigurations = userConfiguration.gridsConfigurations!;
    const normalizedName = gridConfiguration.name.toLowerCase();
    const existingIndex = gridsConfigurations.findIndex(cfg => (cfg.name ?? '').toLowerCase() === normalizedName);

    if (existingIndex >= 0) {
      gridsConfigurations.splice(existingIndex, 1);
    }

    gridsConfigurations.push(gridConfiguration);

    if (this.globals.userLogged) {
      this.globals.userLogged.configuration = JSON.stringify(userConfiguration);
      localStorage.setItem("userLogged", JSON.stringify(this.globals.userLogged));
    }

    return userConfiguration;
  }

  private sanitizeGridConfiguration(gridConfiguration: GridConfiguration): void {
    if (!gridConfiguration.gridColumns) {
      gridConfiguration.gridColumns = [];
      return;
    }

    const seen = new Set<string>();
    const sanitized: GridColumn[] = [];

    gridConfiguration.gridColumns.forEach((column, index) => {
      const name = typeof column === 'string' ? column : column.name;
      if (!name) {
        return;
      }

      const normalized = name.toLowerCase();
      if (seen.has(normalized)) {
        return;
      }

      seen.add(normalized);
      const gridColumn = column instanceof GridColumn ? column : Object.assign(new GridColumn(), column);
      gridColumn.name = name;

      if (gridColumn.id === undefined || gridColumn.id === null) {
        gridColumn.id = index;
      }

      if (gridColumn.position === undefined || gridColumn.position === null) {
        gridColumn.position = sanitized.length + 1;
      }

      sanitized.push(gridColumn);
    });

    gridConfiguration.gridColumns = sanitized;
  }
}
